/**
 * LoveLab “Added to bag!” toast — React Sonner top-right parity.
 * window.llAddedToBagToast.show({ title, description })
 * window.llAddedToBagToast.showFromCartLine(cartAddResponse)
 */
(function () {
  var DURATION_MS = 3000;
  var host = null;

  function i18n(key, fallback) {
    var dict = window.llI18n || {};
    return dict[key] || fallback;
  }

  function ensureHost() {
    if (host && document.body.contains(host)) return host;
    host = document.createElement('div');
    host.className = 'll-added-toast-host';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-relevant', 'additions');
    document.body.appendChild(host);
    return host;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getProp(properties, name) {
    if (!properties) return '';
    if (Array.isArray(properties)) {
      for (var i = 0; i < properties.length; i++) {
        var p = properties[i];
        if (!p) continue;
        var key = p.name || p.first || p[0];
        var val = p.value != null ? p.value : p.last != null ? p.last : p[1];
        if (key === name && val != null && String(val).trim() !== '') return String(val).trim();
      }
      return '';
    }
    if (typeof properties === 'object') {
      var v = properties[name];
      return v != null && String(v).trim() !== '' ? String(v).trim() : '';
    }
    return '';
  }

  function findOptionValue(item, matcher) {
    var opts = item.options_with_values || item.options || [];
    if (Array.isArray(opts)) {
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (!o) continue;
        var name = String(o.name || o.option || '').toLowerCase();
        var value = o.value != null ? o.value : o;
        if (typeof value === 'object') value = value.name || value.value || '';
        if (matcher(name, String(value))) return String(value).trim();
      }
    }
    // Shopify cart/add sometimes only has variant_options as string array
    var variantOpts = item.variant_options;
    if (Array.isArray(variantOpts)) {
      for (var j = 0; j < variantOpts.length; j++) {
        var vo = String(variantOpts[j] || '').trim();
        if (matcher('', vo)) return vo;
      }
    }
    return '';
  }

  function extractCarat(item) {
    var fromOpt = findOptionValue(item, function (name, value) {
      if (/carat|ct/.test(name)) return true;
      return /\d+(\.\d+)?\s*ct/i.test(value);
    });
    if (fromOpt) {
      if (/\d/.test(fromOpt) && !/ct/i.test(fromOpt)) return fromOpt.replace(/\s+/g, '') + ' ct';
      return fromOpt;
    }
    var title = String(item.variant_title || '');
    var m = title.match(/(\d+(?:\.\d+)?)\s*ct/i);
    if (m) return m[1] + ' ct';
    return '';
  }

  function housingSlug(raw) {
    var s = String(raw || '').trim().toLowerCase();
    if (!s) return '';
    if (s.indexOf('yellow') !== -1) return 'yellow';
    if (s.indexOf('white') !== -1) return 'white';
    if (s.indexOf('rose') !== -1 || s.indexOf('pink') !== -1) return 'rose';
    return s;
  }

  function cordHousingPhrase(color, housing) {
    var template = i18n('cordHousing', '{{ color }} cord, {{ housing }} housing');
    return template
      .replace(/\{\{\s*color\s*\}\}/g, color)
      .replace(/\{\{\s*housing\s*\}\}/g, housing);
  }

  function buildDescription(item) {
    if (!item) return '';
    var title = String(item.product_title || item.title || '').trim();
    var carat = extractCarat(item);
    var cord = getProp(item.properties, 'Cord Color') || getProp(item.properties, 'Cord');
    var housingRaw =
      getProp(item.properties, 'Housing') ||
      getProp(item.properties, 'Housing Gold Color') ||
      getProp(item.properties, 'Housing Color');
    var housing = housingSlug(housingRaw);
    var qty = parseInt(item.quantity, 10) || 1;
    var engraving = getProp(item.properties, 'Engraving');

    var desc = title;
    if (cord && housing) {
      var cordUp = (window.llCordLabel ? window.llCordLabel(cord) : cord).toUpperCase();
      var housingLabel =
        window.llHousingNames && window.llHousingNames[housing] ? String(window.llHousingNames[housing]).toLowerCase() : housing;
      var phrase = cordHousingPhrase(cordUp, housingLabel);
      if (carat) desc = title + ' ' + carat + '. ' + phrase;
      else desc = title + ' ' + phrase;
    } else {
      var bits = [];
      if (carat) bits.push(carat);
      var opts = item.options_with_values || [];
      if (Array.isArray(opts)) {
        for (var i = 0; i < opts.length; i++) {
          var o = opts[i];
          if (!o || !o.value) continue;
          var n = String(o.name || '').toLowerCase();
          if (/carat|ct/.test(n)) continue;
          bits.push(window.llOptionValue ? window.llOptionValue(o.name, o.value) : String(o.value));
        }
      }
      if (bits.length) desc = title + ' ' + bits.join(', ');
    }

    if (qty > 1) desc += ' (' + qty + 'x)';
    if (engraving) desc += ' (' + engraving + ')';
    return desc.trim();
  }

  var SUCCESS_ICON =
    '<div class="ll-added-toast__icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20">' +
    '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path>' +
    '</svg></div>';

  function show(opts) {
    opts = opts || {};
    var title = opts.title || i18n('addedToBag', 'Added to bag!');
    var description = opts.description || '';
    var root = ensureHost();

    var el = document.createElement('div');
    el.className = 'll-added-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('data-type', 'success');
    el.innerHTML =
      SUCCESS_ICON +
      '<div class="ll-added-toast__content">' +
      '<div class="ll-added-toast__title">' +
      escapeHtml(title) +
      '</div>' +
      (description
        ? '<div class="ll-added-toast__desc">' + escapeHtml(description) + '</div>'
        : '') +
      '</div>';

    root.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    var removeTimer = setTimeout(function () {
      el.classList.add('is-leaving');
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 220);
    }, DURATION_MS);

    el.addEventListener('click', function () {
      clearTimeout(removeTimer);
      el.classList.add('is-leaving');
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 220);
    });
  }

  function showFromCartLine(item) {
    if (!item || item.status) return;
    show({
      title: i18n('addedToBag', 'Added to bag!'),
      description: buildDescription(item),
    });
  }

  window.llAddedToBagToast = {
    show: show,
    showFromCartLine: showFromCartLine,
    buildDescription: buildDescription,
  };
})();
